import { SHARE_STATISTICS_ROUTE } from './constants';
import http from '../../utils/httpService';
import { getCookie } from '../../utils/cookieService';

/**
 *
 * @param hatchID
 * @param text
 */
const requestStatisticsShare = (hatchID, text) => {
    const uuid = getCookie('uuid');
    const data = {
        uuid_front: uuid,
        shareable_id: hatchID,
        shareable_type: text
    };
    return http.request(SHARE_STATISTICS_ROUTE, 'POST', data );
};

export {
    requestStatisticsShare
};